import React from 'react';
import { Adsense } from '@ctrl/react-adsense';
import useAdsenseScript from '../useAdsenseScript';

const AdsenseProcess = () => {
    useAdsenseScript();

    return (
        <Adsense
            client="ca-pub-7378767920525255"
            slot="6475653947"
            style={{ display: 'block', minHeight: '200px', maxHeight: '300px', maxWidth: '1170px' }}
            format="auto"
            data-full-width-responsive="true"
        />
    );
};

export default AdsenseProcess;
